import React, { useEffect, useState } from "react";
import axios from "./axios";
import "./Row.css";
const base_url = "https://image.tmdb.org/t/p/original/";
function Row({ title, fetchUrl, isLargeRow }) {
  const [movies, setMovies] = useState([]);
  // UseEffect : a snippet of code which runs based on a specific condition
  useEffect(() => {
    //if[] , run once when row loads and dont run again
    //if[movies], run once and whenever movies changes (defined state in useState)
    async function fetchData() {
      const request = await axios.get(fetchUrl);
      setMovies(request.data.results);
      return request;
    }
    //Await function cause we are calling outside , whenever we make a api call in useEffect we do it like this
    //i.e make a function and then call the function
    fetchData();
  }, [fetchUrl]);

  //any variable called from outside will be added to [] because our useEffect is based on fetchUrl
  return (
    <div className="row">
      <h2>{title}</h2>
      <div className="row_posters">
        {/*row posters*/}
        {movies.map((movie) => (
          <img
            key={movie.id}
            className={`row_poster ${isLargeRow && "row_posterLarger"}`}
            src={`${base_url}${
              isLargeRow ? movie.poster_path : movie.backdrop_path
            }`}
            alt={movie.name}
          />
        ))}
      </div>
    </div>
  );
}
export default Row;
